export interface DbSuggestedTask {
  id: string;
  goal_id: string;
  user_id: string;
  title: string;
  description?: string | null;
  status: "pending" | "approved" | "rejected";
  display_order?: number;
  created_at?: string;
  updated_at?: string;
}

export interface SuggestedTask {
  id: string;
  goalId: string;
  userId: string;
  title: string;
  description?: string | null;
  status: "pending" | "approved" | "rejected";
  displayOrder?: number;
  createdAt?: string;
  updatedAt?: string;
}

// Mappers
export function mapDbTaskToUiTask(db: DbSuggestedTask): SuggestedTask {
  return {
    id: db.id,
    goalId: db.goal_id,
    userId: db.user_id,
    title: db.title,
    description: db.description ?? undefined,
    status: db.status as SuggestedTask["status"],
    displayOrder: db.display_order,
    createdAt: db.created_at,
    updatedAt: db.updated_at,
  };
}
